import { Component, OnInit } from '@angular/core';
import { LabeledProductService } from '../../services/labeledproduct.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryService } from '../../../common/services/category.service';
import { LabeledProductShopStockService } from '../../services/labeledproductshopstock.service';
import { Observable } from 'rxjs/Observable';

import { DistributorService } from '../../../distributors/services/distributor.service';

import * as JsBarcode from 'jsbarcode';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
declare let alasql;

@Component({
  selector: 'app-list-labeledproduct',
  templateUrl: './list-labeledproduct.component.html',
  styleUrls: ['./list-labeledproduct.component.css'],
  providers:[LabeledProductService,CategoryService,DistributorService,LabeledProductShopStockService]
})
export class ListLabeledProductComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  labeledProducts: any = [];
  filters:any = {
    barcode:{contains: ""},
    description:{contains: ""},
    storage_capacity: {contains: ""},
    status:{contains: ""},
    name:{contains: ""},
    short_description:{contains: ""},
    manufacturer_barcode:{contains: ""},
    imei1:{contains: ""},
    imei2:{contains: ""},
    serial_number:{contains: ""}
  };
  onlyEditStock: boolean = false;
  onlyWithoutCategory: boolean = false;
  onlyWithStock: boolean = false;
  onlyWithoutStock: boolean = false;
  onlyWithoutCosts: boolean = false;
  exportParams:any = {};
  selectedImage: any = null;
  filteredDistributors: any = [];
  selectedDistributor: string = "";
  distributors: any = [];
  config: any = {'sourceField': ['name']};
  selectedlabeledProduct: any = null;
  showExportButton:boolean = true;
  role:number = 3;

  constructor(private labeledProductService: LabeledProductService, private route: ActivatedRoute, private router: Router,private categoryService:CategoryService,
    private distributorService:DistributorService, private labeledProductShopStockService:LabeledProductShopStockService) { }

  ngOnInit() {
    if (this.route.url['_value'][1].path.includes("listtoeditstock")){
      this.onlyEditStock = true;
    }
    this.getDistributors();
    this.getLabeledProducts();
    setTimeout(function (){
      document.getElementById("barcode-filter").focus();
    },100);
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }

  getNameProductType(type){
    var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
    return productType[type-1];
  }

  getDistributor(value){
    if (value.id){
      this.filters.distributor = value.id;
    }else{
      delete this.filters.distributor;
    }
    this.get();
  }

  filterDistributors(value){
    this.selectedDistributor = value;
    this.filteredDistributors = _.filter(this.distributors, function(o) { return o.name.toLowerCase().includes(value.toLowerCase()); });
    if (value == ""){
      delete this.filters.distributor;
      this.get();
    }
  }

  getDistributors(){
    this.distributorService.query({})
    .subscribe((distributors) => {
        this.distributors = distributors;
        this.filteredDistributors = distributors;
    }); 
  }
  
  get(){
    if (this.onlyWithoutCategory){
      this.getLabeledProductsWithoutCategories();
    }else{
      if (this.onlyWithoutCosts){
        this.filters.or = [
          {shipping_cost_tenerife: null},
          {shipping_cost_canary_island: null},
          {shipping_cost_mainland: null}
        ]
      }else{
        delete this.filters.or;
      }
      if (this.onlyWithStock){
        this.filters.stock = {
          '>' : 0
        }
      }
      if (this.onlyWithoutStock){
        this.filters.stock = {
          '<=' : 0
        }
      }
      if (!this.onlyWithoutStock && !this.onlyWithStock){
        delete this.filters.stock
      }
      this.getLabeledProducts();
    }
  }
  
  getLabeledProducts(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    this.exportParams = params;
    this.labeledProductService.query(params)
      .subscribe((labeledProducts) => {
          this.labeledProducts = labeledProducts;
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.labeledProductService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
            if (this.totalItems == 1 && this.onlyEditStock){
              this.router.navigate(['/labeledproduct/editStock/'+labeledProducts[0].id])
            }
          });
          labeledProducts.forEach((labeledProduct)=>{
            this.getCategoryTree(labeledProduct);
            this.getProductPhotos(labeledProduct);
          });
      });
  }

  getLabeledProductsWithoutCategories(){
    var params = {
      skip: (this.p-1)*10,
      limit: 10
    };
    this.labeledProductService.getLabeledProductsWithoutCategories(params)
      .subscribe((labeledProducts) => {
          this.labeledProducts = labeledProducts;
          this.labeledProductService.getLabeledProductsWithoutCategories({})
          .subscribe((labeledProducts) => {
            this.totalItems = labeledProducts.length;
          });
          labeledProducts.forEach((labeledProduct)=>{
            this.getCategoryTree(labeledProduct);
            this.getProductPhotos(labeledProduct);
          });
      });
  }

  getCategoryTree(labeledProduct){
    if (labeledProduct.category && labeledProduct.category.length > 0){
      this.categoryService.query({id:labeledProduct.category[0].category})
      .subscribe((subfamily) => {
        labeledProduct.naturalSubfamily = subfamily.name;
        var params = {
            where:{
                id:subfamily.parent_id
            }
        }
        this.categoryService.query(params)
        .subscribe((family) => {
          labeledProduct.naturalFamily = family[0].name;
            var params2 = {
                where:{
                    id:family[0].parent_id
                }
            }
            this.categoryService.query(params2)
            .subscribe((category) => {
              labeledProduct.naturalCategory = category[0].name;
            });
        });
      });
    }
  }

  getProductPhotos(labeledProduct){
    this.labeledProductService.getProductPhotos(labeledProduct.id)
    .subscribe((result) => {
      if (result && result[0]){
      labeledProduct.image = result[0].image;
      }
    })
  }

  getLabeledProductStock(labeledProduct){
    let params = {
      labeledproduct: labeledProduct.id
    }
    this.labeledProductShopStockService.query(params).subscribe((labeledProductShopStocks) => {
      var result = "Stock por Tienda: \n";
      labeledProductShopStocks.forEach((e)=>{
        result+="-"+e.shop.name+": "+e.stock+"\n";
      })
      alert(result);
    });
  }

  selectImage(src){
    window.scroll(0,0);
    this.selectedImage = src;
  }
  unselectImage(){
    this.selectedImage = null;
  }

  printTags(selectedlabeledProduct){
    this.selectedlabeledProduct = selectedlabeledProduct;
    if (this.selectedlabeledProduct.barcode){
      setTimeout( ()=>{
          JsBarcode("#barcode",this.selectedlabeledProduct.barcode,{format: "CODE128",width:7,fontSize: 50,textMargin:-12,margin:0, height: 70});
          this.selectedlabeledProduct.barcode_img = document.getElementById('barcode-div').getElementsByTagName('img')[0].src;
          setTimeout( ()=>{
            document.getElementById("ticket").classList.remove('hide')
            window.print();
            document.getElementById("ticket").classList.add('hide')
          },0);
      },0);
    }
  }

  exportLabeledProductsToExcel(){
    this.showExportButton = false;
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Código de barras",
              field2:"Nombre",
              field3:"Descripción corta",
              field4:"Descripción",
              field5:"Stock",
              field6:"Precio de compra",
              field7:"Precio de venta",
              field8:"Distribuidor",
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      let observableLabeledProductsRequest = [];
      let request = Math.ceil(this.totalItems / 100);
      for (let i=0; i<request;i++){
        this.exportParams.skip = ((i)*100),
        this.exportParams.limit = 100
        // this.exportParams.skip = ((i-1)*100)+86,
        // this.exportParams.limit = 1
        if (this.onlyWithoutCategory){
          observableLabeledProductsRequest.push(this.labeledProductService.getLabeledProductsWithoutCategories(this.exportParams));
        }else{
          observableLabeledProductsRequest.push(this.labeledProductService.query(this.exportParams));
        }
      }
      Observable.forkJoin(observableLabeledProductsRequest)
          .subscribe(data => {
            let p:any = data;
            let labeledProducts = p.flat(); 
                labeledProducts.forEach(labeledproduct =>{
                  if (labeledproduct.short_description){
                    labeledproduct.short_description = labeledproduct.short_description.replace(/</g, '');
                    labeledproduct.short_description = labeledproduct.short_description.replace(/>/g, '');
                    labeledproduct.short_description = labeledproduct.short_description.replace(/;/g, '');
                    labeledproduct.short_description = labeledproduct.short_description.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  if (labeledproduct.description){
                    labeledproduct.description = labeledproduct.description.replace(/</g, '');
                    labeledproduct.description = labeledproduct.description.replace(/>/g, '');
                    labeledproduct.description = labeledproduct.description.replace(/;/g, '');
                    labeledproduct.description = labeledproduct.description.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  if (labeledproduct.name){
                    labeledproduct.name = labeledproduct.name.replace(/</g, '');
                    labeledproduct.name = labeledproduct.name.replace(/>/g, '');
                    labeledproduct.name = labeledproduct.name.replace(/;/g, '');
                    labeledproduct.name = labeledproduct.name.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
                  }
                  var row = {
                      field1:labeledproduct.barcode?labeledproduct.barcode:"",
                      field2:labeledproduct.name?labeledproduct.name:"",
                      field3:labeledproduct.short_description?labeledproduct.short_description:"",
                      field4:labeledproduct.description?labeledproduct.description:"",
                      field5:labeledproduct.stock?labeledproduct.stock:"",
                      field6:labeledproduct.purchase_price?labeledproduct.purchase_price:"",
                      field7:labeledproduct.sale_price?labeledproduct.sale_price:"",
                      field8:labeledproduct.distributor?labeledproduct.distributor.name:"",
                  }
                  report.push(row);
              });
              var mystyle = {   
                  headers:true,       
                  columns:    
                      [{columnid:'field1',width:100,title: ''},   
                      {columnid:'field2',width:100,title: ''},
                      {columnid:'field3',width:100,title: 'LISTADO DE PRODUCTOS ETIQUETADOS'},
                      {columnid:'field4',width:300,title: ''},
                      {columnid:'field5',width:100,title: ''},
                      {columnid:'field6',width:100,title: ''},
                      {columnid:'field7',width:100,title: ''},
                      {columnid:'field8',width:100,title: ''}, 
                      
                      ],
                  /*header*/
                
                  column: {  
                      style:{
                          Alignment:{
                              Horizontal:"Center",
                              Vertical:"Center",  
                              WrapText:1
                              
                          },
                          Font:{
                              Bold:"1",
                              Color:"#000000",
                              Size:10
                          },
                          
                          Interior:{
                              Color:"#7CEECE",
                              Pattern:"Solid"
                          }
                      }},
                cells: {    
                      0:{
                          0:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid",
                                      },
                              Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                  },  
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                              },                        
                              }  
                          },
                          1:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                          },  
                              Font:{
                                      Size:10,
                                      Bold:"1",
                                      Color:"#000000",
                              },            
                                  }
                          },
                          2:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      }, 
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          }                
                                  }
                              },
                          3:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },            
                                    
                                  }
                              },
                          4:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                      },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              },
                          5:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                           
                                  }
                              }, 
                          6:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1, 
                              },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                          },                             
                              }
                              },
                          7:{style:{
                              Interior:{ 
                                  Color:"#95a5a6",
                                  Pattern:"Solid"
                                          },
                              Alignment:{
                                  Horizontal: 'Center', 
                                  Vertical: 'Center',
                                  WrapText: 1,
                                      },
                              Font:{
                                  Size:10,
                                  Bold:"1",
                                  Color:"#000000",
                                  },              
                              }
                            },
                      }   
                },
          };
          this.showExportButton = true;
          alasql.promise('SELECT * INTO XLSXML("ProductosEtiquetados_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
          .then(function(data){
              console.log('Data saved');
          }).catch(function(err){
              console.log('Error:', err);
          });
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/labeledproducts/components/list-labeledproduct/list-labeledproduct.component.ts